import { NavLink } from "react-router-dom";
import "./User.css"; // Style your tabs here

const UserNavBar = () => (
  <nav className="user-nav-bar">
    <NavLink to="profile" className={({ isActive }) => isActive ? "tab active" : "tab"}>
    {({ isActive }) => (
        <>
        {isActive ? <i className="fa-solid fa-user"></i> : <i className="fa-regular fa-user"></i>} Profile
        </>
    )}
    </NavLink>

    <NavLink to="two-factor" className={({ isActive }) => isActive ? "tab active" : "tab"}>
    {({ isActive }) => (
        <>
        {isActive ? <i className="fa-solid fa-shield"></i> : <i className="fa-solid fa-shield-halved"></i>} Two Factor Authentication
        </>
    )}
    </NavLink>

    {/* Add more tabs as needed */}
  </nav>
);

export default UserNavBar;